import { useAssignmentEvents } from 'src/hooks/use-assignment-events.hook';
import useAssignmentsRegularUpdate from 'src/hooks/use-assignments-regular-update.hook';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { getAmpConfigFlags } from 'src/services/amp-config.service';

import { ElementarySchoolSections } from '../elementary-school-view/elementary-school-sections';
import { MsAssignments } from '../middle-school-view';
import { MsSections } from '../middle-school-view/ms-sections';

const Assignments = () => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  useAssignmentsRegularUpdate();
  useAssignmentEvents();

  // TODO: Remove the feature flag after RFS.
  const isUpdatedMSViewEnabled = getAmpConfigFlags().isUpdatedMSViewEnabled;

  if (isMiddleSchoolView) {
    return isUpdatedMSViewEnabled ? <MsSections /> : <MsAssignments />;
  }

  return <ElementarySchoolSections />;
};

export default Assignments;
